module.exports = __webpack_public_path__ + "img/stuDetailIcon5@2x.b5fad585.png";